export default function convertToUnEscape(txt) {
    return unescape(txt);
}